import { ThemeConfig } from 'antd/es/config-provider';

const theme: ThemeConfig = {
  inherit: false,
  token: {
    colorPrimary: '#2A4BC2',
  },
  components: {
    Typography: {
      colorText: 'rgba(25, 33, 38, 1)',
    },
    Input: {
      controlOutline: '1px solid #1c8271',
      hoverBorderColor: '#1c8271',
    },
    Button: {
      defaultHoverBorderColor: '#1c8271',
    },
    Menu: {
      padding: 0,
      colorBorderBg: 'unset',
      colorActiveBarHeight: 0,
      colorPrimaryBg: 'unset',
    },
    Layout: {
      colorBgLayout: 'unset',
      headerBg: 'unset',
      bodyBg: 'unset',
      siderBg: '#F8F8F9',
    },
    Select: {
      selectorBg: 'transparent',
      colorBorder: 'transparent',
      activeBorderColor: 'transparent',
      hoverBorderColor: 'transparent',
    },
    Card: {
      borderRadius: 24,
      borderRadiusOuter: 24,
      borderRadiusLG: 24,
      borderRadiusSM: 24,
      borderRadiusXS: 24,
    },
  },
};

export default theme;
